import Terms from '../../components/Terms';

export default Terms;
